module.exports = __webpack_public_path__ + "img/shayan-schools-mono-white.896bc673.svg";